import React from "react";
import { SUCURSALES, INICIALES, COLORES } from "../../utils/constants";


const ResumenAsignados = ({ data, handleDelete, handleCupon, opcion }) => {
    console.log('data ResumenAsignados:::', data[0].Cargos, opcion)
    return (
        <div className={"/grid bg-primarioMira rounded-md mt-8  w-full /justify-center "}>
            <div className={"grid content-center"}>
                <p className={"text-white mx-auto font-medium text-2xl mt-2 text-center"}>
                    {opcion === 1
                        ? 'Curso seleccionado para cambio de horario'
                        : opcion === 2
                            ? 'Curso seleccionado para traslado de fondos'
                            : 'Curso seleccionado para devolución'
                    }
                </p>
            </div>
            <div role="list" className="content-center p-4 mt-1 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 gap-1  sm:gap-6  mb-4 w-full mx-auto /bg-red-200">{/* w-full es de prueba*/}
                {data.map((project, index) => (
                    (project?.Pagar || project?.Pagado || project?.Cobrado || project?.Seleccionado) && /*(opcion !== 0 ? index === 0 : 1 === 1) &&*/
                    <div key={index} className=" /max-w-sm p-2 mt-2  bg-secundarioMira rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 ring-1 ring-blueGray-50">

                        <div className="|bg-green-200 w-full">
                            <div className="flex flex-row w-full">
                                {project.hasOwnProperty("Imagen") ?
                                    project?.Imagen !== '' ?
                                        <img
                                            className="w-10 mr-1"
                                            src={`./img/cursos/${project?.Imagen}`}></img>
                                        : null : null}
                                <p className="|mb-1 font-medium text-white text-sm my-auto">{project?.Cargo}</p>
                            </div>
                            <p className="/mb-3 text-xs text-white">
                                {project?.DescripcionPlan}
                            </p>
                            <div className="text-gray-400 flex flex-col xl:flex-row /justify-between text-sm p-0 justify-between xl:mr-2">
                                <div className="inline-flex flex-col">
                                    <p className="inline text-white mr-2">Inicio:</p> {project?.De}</div>
                                <div className="inline-flex flex-col">
                                    <p className="inline text-white |xl:ml-4 |mr-2">Fin:</p>{project?.A}</div>
                            </div>
                        </div>

                        <p className="text-white">Cupones aplicados:</p>
                        <div className="w-full">
                            {
                                project.Cupones.map((cupon, index) => (
                                    <div className="w-full flex  flex-row">
                                        <div className="w-1/2 justify-start">
                                            <p key={index} className="text-gray-400 text-sm flex w-full">
                                                {cupon.NombreCupon}
                                            </p>
                                        </div>
                                        <div className="w-1/2 text-end">
                                            <p key={index} className="text-secundario text-sm ">
                                                Q.{cupon.ValorCupon}.00
                                            </p>
                                        </div>
                                    </div>
                                ))
                            }
                            <hr></hr>
                            <div className="flex flex-row justify-between">
                                <p className="text-gray-400 text-sm">Total descuento:</p>
                                <p className="text-sm text-secundario">Q.{project?.Cupones.reduce((prev, next) => prev + next.ValorCupon, 0)}.00</p>
                            </div>
                        </div>

                        {!project?.Cobrado ? /* project?.precioAnterior */
                            <div className="flex flex-row /xl:flex-col w-full justify-end gap-2">
                                <div className="flex w-1/2 flex-col">
                                    <p className="text-white text-sm m-auto">Sin descuento</p>
                                    <p className={!project?.Cobrado ? "p-1 m-auto rounded-md /bg-red-500 inline /mx-auto font-medium text-sm xl:text-md tracking-tight text-red-500  line-through" : "inline mx-auto text-xs xl:text-sm tracking-tight  dark:text-white line-through text-secundarioMira"}>
                                        Q {project?.precioAnterior || (project?.Valor)}.00
                                    </p>
                                </div>
                                <div className="flex w-1/2 flex-col">
                                    <p className="text-white text-sm m-auto">Ahora</p>
                                    <p className="/bg-green-500 inline /mx-auto text-md xl:text-md font-medium tracking-tight text-green-500  |line-through p-1 rounded-md mx-auto">
                                        Q {project?.Valor}.00
                                    </p>
                                </div>
                            </div>
                            :
                            <div className="flex w-full flex-row justify-between">
                                <p className="text-white text-sm ">Total</p>
                                <p className=" text-md xl:text-md font-medium tracking-tight text-green-500 p-1 ">
                                    {project?.Cobrado ? `PAGADO Q ${project?.Pagado}.00` : ` Q ${project?.Valor}.00`}
                                </p>
                            </div>
                        }
                        {project?.Cobrado &&
                            <div className="flex w-full flex-row justify-between">
                                <p className="text-white text-sm  my-auto">Fecha de cobro</p>
                                <p className=" text-md xl:text-md font-medium tracking-tight text-secundario p-1 my-auto">
                                    {`${project?.FechaCobrado}`}
                                </p>
                                <p className="text-white text-sm my-auto">Recibo</p>
                                <p className=" text-md xl:text-md font-medium tracking-tight text-secundario p-1 my-auto">
                                    {`${project?.ReciboCobro}`}
                                </p>
                            </div>
                        }
                        <div className="flex justify-between |-mt-1 |xl:-mt-3 w-full">
                            {INICIALES[project?.IdSede] &&
                                <div className="flex flex-row  w-full my-2">
                                    <div className=" w-3/4">
                                        <p className={`inline text-${COLORES[project?.IdSede]}`}>{`${INICIALES[project?.IdSede]} - ${SUCURSALES[project?.IdSede]}`}</p>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ResumenAsignados;
